'use strict';
/**
 * API 调用过程中的 Token Keeper:
 * token: 某次调用的timestamp, token 阅后即焚 -> 保证不重复调用
 * timeout: API超时 -> token 失效
 * trigger: 超时回调
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Keeper = function () {
    function Keeper() {
        var _this = this;

        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : opt,
            type = _ref.type,
            token = _ref.token,
            timeout = _ref.timeout,
            trigger = _ref.trigger;

        _classCallCheck(this, Keeper);

        this.token = token;
        if (token && parseInt(timeout)) {
            this._timeout = setTimeout(function () {
                typeof trigger == 'function' && trigger(_this.token);
                _this.token = null;
            }, timeout);
        }
    }

    _createClass(Keeper, [{
        key: 'getToken',
        value: function getToken() {
            var ret = this.token;
            if (!ret) return ret; // 计时器结束/token被读过了
            clearTimeout(this._timeout); // 结束计时
            this.token = null; // 销毁
            return ret;
        }
    }]);

    return Keeper;
}();

exports.default = Keeper;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/keeper.js
// module id = 485
// module chunks = 1 12 14